import { BasicLayout } from '@doda/pc/src/components/layouts/BasicLayout';
import { HEADER_NAV_MENU } from '@doda/pc/src/constants/headerNavMenu';
import { Provider } from 'react-redux';
import { PageViewAnalytics } from 'components/PageViewAnalytics';
import { InferGetServerSidePropsType } from 'next';
import { makeStore } from '@doda/pc/src/redux/store';
import { getServerSideProps } from './getServerSideProps';
import { JobSearchTopScreen } from './screens/JobSearchTopScreen';

const JobSearchTop = (
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) => {
  const {
    isLogin,
    jobCount,
    linkAreaHtml,
    masterData,
    previousConditionData,
    initialConditions,
    initialState,
  } = props;

  const store = makeStore({ preloadedState: initialState });

  return (
    <Provider store={store}>
      <BasicLayout selectedNavItem={HEADER_NAV_MENU.SEARCH}>
        <PageViewAnalytics pageName="求人検索トップ" />
        <JobSearchTopScreen
          isLogin={isLogin}
          jobCount={jobCount}
          linkAreaHtml={linkAreaHtml}
          masterData={masterData}
          previousConditionData={previousConditionData}
          initialConditions={initialConditions}
        />
      </BasicLayout>
    </Provider>
  );
};

export { getServerSideProps };

export default JobSearchTop;
